"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pick = void 0;
function pick(obj, keys, options) {
    const { onMissingKey = "addUndefined" } = options ?? {};
    const out = {};
    for (const key of keys) {
        if (!(key in obj) && onMissingKey === "skip")
            continue;
        out[key] = obj[key];
    }
    return out;
}
exports.pick = pick;
//# sourceMappingURL=pick.js.map